// import { useQuery } from "@tanstack/react-query";
// import { fetch3 } from "../commonApis/commonApis";
// import { useSelector } from "react-redux";
// const url = process.env.REACT_APP_BASE_URL;

// export const useFetchOrderSummary = (summaryType: string) => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["orderSummary", profile?.id, summaryType],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/order-summary?type=${summaryType}`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetchOFDOrderSummary = (summaryType: string) => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["ofdOrderSummary", profile?.id, summaryType],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/ofd-summary?type=${summaryType}`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetchFleetSummary = () => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["fleetSummary", profile?.id],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/fleet-summary`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetchCodWalletAnalytics = (range: string) => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["codWalletAnalytics", profile?.id, range],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/cod-wallet-analytics?filter=${range}`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetchRecentCODOrders = () => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["recentCODOrders", profile?.id],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/recent-cod-orders`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetchSaleOverview = (summaryType: string) => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["saleOverview", profile?.id, summaryType],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/sale-overview?type=${summaryType}`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetch3plForwardOrders = (summaryType: string) => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["3plForwardOrders", profile?.id, summaryType],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/3pl-channels-forward-orders?type=${summaryType}`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetchTop10DriverPerformance = (summaryType: string) => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["driverPerformance", profile?.id, summaryType],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/driver-performance?type=${summaryType}`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetchTop10ClientPerformance = (summaryType: string) => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["clientPerformance", profile?.id, summaryType],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/client-performance?type=${summaryType}`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// export const useFetchOrdersGraph = () => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["orderGraph", profile?.id],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/order-graph`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// };

// // Driver list api by Iram

// export const useFetchDriverList = (summaryType: string) => {
//     const profile = useSelector((state: any) => state.auth.profile);
//     return useQuery({
//         queryKey: ["driverList", profile?.id, summaryType],
//         queryFn: async () => {
//             const res = await fetch3(`${url}/api/dashboard/driver-performance?type=Today&limit=20`, "get");

//             if (!res || !res.data) {
//                 return res.message;
//             }

//             return res.data;
//         },
//         staleTime: 1000 * 60 * 5,
//     });
// }

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetch3, fetch4, fetch5 } from "../commonApis/commonApis";
import { useSelector } from "react-redux";

const url = process.env.REACT_APP_BASE_URL;

export type SummaryPeriod =
  | "Today"
  | "Yesterday"
  | "Last 7 Days"
  | "Last 30 Days"
  | "All Time";

export const useFetchOrderSummary = ({
  type,
  startDate,
  endDate,
}: {
  type?: string;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["orderSummary", profile?.id, type, startDate, endDate],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();

      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const res = await fetch3(
        `${url}/api/dashboard/order-summary?${params.toString()}`,
        "get",
      );

      return res?.data ?? null;
    },
  });
};

// Fetch LM / FM / Total order counts
export const useFetchOrderTypeSummary = () => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["orderTypeSummary", profile?.id],
    enabled: !!profile?.id,
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/dashboard/order-type-summary`,
        "get",
      );

      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};


export const useFetchOrderSummaryLMFM = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["orderSummaryLMFM", profile?.id, type, startDate, endDate],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const res = await fetch3(`${url}/api/dashboard/order-summary-lmfm?${params.toString()}`, "get");

      return res?.data ?? null;
    },
  });
};

// New hook for status trend
export interface StatusTrendItem {
  day: string;
  delivered: number;
  notDelivered: number;
  ofd: number;
}

export const useFetchStatusTrend = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery<StatusTrendItem[]>({
    queryKey: ["statusTrend", profile?.id, type, startDate, endDate],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const res = await fetch3(`${url}/api/dashboard/status-trend?${params.toString()}`, "get");
      return res?.data ?? [];
    },
    staleTime: 1000 * 60 * 5,
  });
};


export const useFetchOFDOrderSummary = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["ofdOrderSummary", profile?.id, type, startDate, endDate],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const res = await fetch3(
        `${url}/api/dashboard/ofd-summary?${params.toString()}`,
        "get",
      );

      return res?.data ?? null;
    },
  });
};

export const useFetchFleetSummary = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["fleetSummary", profile?.id, type, startDate, endDate],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const res = await fetch3(
        `${url}/api/dashboard/fleet-summary?${params.toString()}`,
        "get",
      );

      return res?.data ?? null;
    },
  });
};

export const useFetchCodWalletAnalytics = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["codWalletAnalytics", profile?.id, type, startDate, endDate],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const res = await fetch3(
        `${url}/api/dashboard/cod-wallet-analytics?${params.toString()}`,
        "get",
      );

      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchRecentCODOrders = () => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["recentCODOrders", profile?.id],
    enabled: !!profile?.id,
    queryFn: async () => {
      const res = await fetch3(`${url}/api/dashboard/recent-cod-orders`, "get");
      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchSaleOverview = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["saleOverview", profile?.id, type, startDate, endDate],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      const res = await fetch3(
        `${url}/api/dashboard/sale-overview?${params.toString()}`,
        "get",
      );
      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetch3plForwardOrders = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: [
      "3plForwardOrders",
      profile?.id,
      type,
      startDate,
      endDate,
    ],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();

      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const res = await fetch3(
        `${url}/api/dashboard/3pl-channels-forward-orders?${params.toString()}`,
        "get"
      );

      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};


export const useFetchTop10DriverPerformance = ({
  type,
  startDate,
  endDate,
  limit = 10,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
  limit?: number;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: [
      "driverPerformance",
      profile?.id,
      type,
      startDate,
      endDate,
      limit,
    ],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();

      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      params.append("limit", String(limit));
      const res = await fetch3(
        `${url}/api/dashboard/driver-performance?${params.toString()}`,
        "get",
      );
      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchDriverWiseOrderStatus = ({
  type,
  startDate,
  endDate,
  limit = 10,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
  limit?: number;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: [
      "driverWiseOrderStatus",
      profile?.id,
      type,
      startDate,
      endDate,
      limit,
    ],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      params.append("limit", String(limit));

      const res = await fetch3(
        `${url}/api/dashboard/driver-wise-order-status?${params.toString()}`,
        "get",
      );

      return res?.data ?? [];
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchMerchantWiseShipmentDetails = ({
  type,
  startDate,
  endDate,
  limit = 15,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
  limit?: number;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: [
      "merchantWiseShipmentDetails",
      profile?.id,
      type,
      startDate,
      endDate,
      limit,
    ],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      params.append("limit", String(limit));

      const res = await fetch3(
        `${url}/api/dashboard/merchant-wise-shipment-details?${params.toString()}`,
        "get",
      );

      return res?.data ?? [];
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchCODCollectionSummary = ({
  type,
  startDate,
  endDate,
  limit = 10,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
  limit?: number;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: [
      "codCollectionSummary",
      profile?.id,
      type,
      startDate,
      endDate,
      limit,
    ],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      params.append("limit", String(limit));

      const res = await fetch3(
        `${url}/api/dashboard/cod-collection-summary?${params.toString()}`,
        "get",
      );

      return res?.data ?? [];
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchTop10ClientPerformance = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["clientPerformance", profile?.id, type, startDate, endDate],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      const res = await fetch3(
        `${url}/api/dashboard/client-performance?${params.toString()}`,
        "get",
      );
      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchOrdersGraph = () => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["orderGraph", profile?.id],
    enabled: !!profile?.id,
    queryFn: async () => {
      const res = await fetch3(`${url}/api/dashboard/order-graph`, "get");
      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchDriverList = (summaryType: string, limit = 20) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["driverList", profile?.id, summaryType, limit],
    enabled: !!profile?.id,
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/dashboard/driver-performance?type=${summaryType}&limit=${limit}`,
        "get",
      );
      return res?.data ?? null;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useFetchDriverCODPerformance = ({
  type,
  startDate,
  endDate,
  limit = 10,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
  limit?: number;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: [
      "driverCODPerformance",
      profile?.id,
      type,
      startDate,
      endDate,
      limit,
    ],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();

      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      params.append("limit", String(limit));

      const res = await fetch3(
        `${url}/api/dashboard/driver-cod-performance?${params.toString()}`,
        "get",
      );

      return res?.data ?? [];
    },
  });
};

// Merchant COD order ghaph api
export const useFetchMerchantCODGraph = ({
  type,
  startDate,
  endDate,
  limit = 15,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
  limit?: number;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: [
      "merchantCODGraph",
      profile?.id,
      type,
      startDate,
      endDate,
      limit,
    ],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      params.append("limit", String(limit));

      const res = await fetch3(
        `${url}/api/dashboard/merchant-cod-graph?${params.toString()}`,
        "get",
      );

      return res?.data ?? [];
    },
  });
};

// Saudi Province map 

export interface SaudiProvinceOrders {
  province: string;
  totalOrders: number;
}

export const useFetchOrdersBySaudiProvince = ({
  type,
  startDate,
  endDate,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery<SaudiProvinceOrders[]>({
    queryKey: [
      "ordersBySaudiProvince",
      profile?.id,
      type,
      startDate,
      endDate,
    ],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);

      const res = await fetch3(
        `${url}/api/dashboard/orders-by-saudi-province?${params.toString()}`,
        "get"
      );

      return res?.data ?? [];
    },
    staleTime: 1000 * 60 * 5,
  });
};

export interface CityRegionBreakdownItem {
  city: string;
  region: string;
  total: number;
  ofd: number;
  delivered: number;
  notDelivered: number;
  drivers: number;
  successRate: number;
}

export const useFetchCityRegionBreakdown = ({
  type,
  startDate,
  endDate,
  limit = 100,
}: {
  type?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
  limit?: number;
}) => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery<CityRegionBreakdownItem[]>({
    queryKey: [
      "cityRegionBreakdown",
      profile?.id,
      type,
      startDate,
      endDate,
      limit,
    ],
    enabled: !!profile?.id,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (startDate) params.append("startDate", startDate);
      if (endDate) params.append("endDate", endDate);
      params.append("limit", String(limit));

      const res = await fetch3(
        `${url}/api/dashboard/city-region-breakdown?${params.toString()}`,
        "get",
      );

      return res?.data ?? [];
    },
    staleTime: 1000 * 60 * 5,
  });
};

export interface WhitelistedApiItem {
  id: string;
  name: string;
  endpoint: string;
  method: string;
  description: string;
  category: "Orders" | "Fleet" | "Finance" | "Performance" | "Geography";
  recommendedWidget: "stat" | "pie" | "bar" | "line" | "table";
}

export const useFetchAvailableApis = () => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery<WhitelistedApiItem[]>({
    queryKey: ["availableApis", profile?.id],
    enabled: !!profile?.id,
    queryFn: async () => {
      const res = await fetch3(`${url}/api/dashboard/available-apis`, "get");
      return res?.data ?? [];
    },
    staleTime: 1000 * 60 * 15,
  });
};

export const useFetchCustomLayout = () => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["customDashboardLayout", profile?.id],
    enabled: !!profile?.id,
    queryFn: async () => {
      const res = await fetch3(`${url}/api/dashboard/custom-layout`, "get");
      return res?.data ?? null;
    },
    staleTime: 1000 * 30,
  });
};

export const useSaveCustomLayout = () => {
  const queryClient = useQueryClient();
  const profile = useSelector((state: any) => state.auth.profile);

  return useMutation({
    mutationFn: async (layout: any) => {
      const res = await fetch4(`${url}/api/dashboard/custom-layout`, {
        layout,
      });
      return res?.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["customDashboardLayout", profile?.id],
      });
    },
  });
};

export const useDeleteCustomLayout = () => {
  const queryClient = useQueryClient();
  const profile = useSelector((state: any) => state.auth.profile);

  return useMutation({
    mutationFn: async () => {
      const res = await fetch5(`${url}/api/dashboard/custom-layout`, "DELETE");
      return res;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["customDashboardLayout", profile?.id],
      });
    },
  });
};

export const useGrafanaStatus = () => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["grafanaStatus", profile?.id],
    queryFn: async (): Promise<boolean> => {
      try {
        const res = await fetch3(`${url}/api/grafana/status`, "get");
        if (typeof res?.isRunning === "boolean") {
          return res.isRunning;
        }
        if (typeof res?.data?.isRunning === "boolean") {
          return res.data.isRunning;
        }
      } catch {
        // Fallback to direct client ping
      }

      const grafanaUrl =
        process.env.REACT_APP_GRAFANA_URL || "http://localhost:3001";
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 1500);
        await fetch(`${grafanaUrl}/api/health`, {
          signal: controller.signal,
          mode: "no-cors",
        });
        clearTimeout(timeoutId);
        return true;
      } catch {
        return false;
      }
    },
    staleTime: 1000 * 30,
    refetchOnWindowFocus: true,
  });
};

export const useFetchAdminGrafanaDashboard = () => {
  const profile = useSelector((state: any) => state.auth.profile);

  return useQuery({
    queryKey: ["adminGrafanaDashboard", profile?.id],
    enabled: !!profile?.id,
    queryFn: async () => {
      const res = await fetch3(`${url}/api/grafana/admin-dashboard`, "get");
      if (res?.isRunning === false) {
        return null;
      }
      return res?.dashboardUrl || res?.data?.dashboardUrl || null;
    },
    staleTime: 1000 * 60 * 5,
  });
};





